import React from 'react';
import {
  string, number, bool, func,
} from 'prop-types';
import { Link } from 'gatsby';
import styles from './MenuItem.module.scss';
import DefaultParagraph from '../../typeface/DefaultParagraph';

const MenuItem = ({
  num,
  title,
  to,
  active,
  toggleMenu,
}) => (
  <Link
    onClick={toggleMenu}
    to={`${to}`}
    className={styles.container}
  >
    <DefaultParagraph
      xsmall
      className={[
        styles.textNumber,
        active && styles.textNumberActive,
      ].join(' ')}
    >
      {`0${num}.`}

    </DefaultParagraph>
    <div>
      <h2 className={styles.titleMenuItem}>{title}</h2>
      <div className={active ? styles.titleActive : null} />
    </div>
  </Link>
);

MenuItem.propTypes = {
  num: number,
  title: string,
  active: bool,
  to: string,
  toggleMenu: func.isRequired,
};

MenuItem.defaultProps = {
  num: null,
  title: null,
  active: false,
  to: null,
};

export default MenuItem;
